export const pxpConfig = {
  doNotPromote: {
    label: 'Do Not Promote',
    type: 'checkbox',
  },
};
